import { render, staticRenderFns } from "./deanSidemenu.vue?vue&type=template&id=437ea5ee&scoped=true"
import script from "./deanSidemenu.vue?vue&type=script&lang=ts"
export * from "./deanSidemenu.vue?vue&type=script&lang=ts"
import style0 from "./deanSidemenu.vue?vue&type=style&index=0&id=437ea5ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437ea5ee",
  null
  
)

export default component.exports